import React, { useState } from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import FromToDatePicker from "../../../../library/custom/datePicker/DatePicker";
import { Card, CardContent, Box, CardActions } from "@mui/material";
import Buttons from "../../../../library/custom/button/Button";
import Grid from "@mui/material/Grid";
import { getFormatedDate } from "../../../../utils/helper";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import {
  INCIDENT_STATUS,
  ITEM_TYPE,
  ORIGIN,
  USER_ID,
} from "../../../../constant/constant";
import commonImages from "../../../../assets";
import "./FilterIncidentList.scss";
import SelectMenu from "../../../../library/custom/selectMenu/SelectMenu";
import { ASSETTYPE } from "../../../../constant/inspectionConstant";
const FilterIncidentList = ({
  id,
  open,
  anchorEl,
  handleClose,
  handleSearch,
  filterType,
  resetFilterAPI,
  bothRecords,
  itemTypes,
  assetTypes,
  assetTypeId,
  typeOnAssetChanges,
  origin = false,
  originId,
  typeOnOriginChanges,
}) => {
  //filter kudos // reperemind // violation
  const [filter, setFilter] = useState({
    startDate: "",
    endDate: "",
    status: 2,
  });

  const resetFilter = () => {
    setFilter({
      startDate: "",
      endDate: "",
      status: 2,
      userId: parseInt(USER_ID()),
      itemTypes: itemTypes,
    });
    resetFilterAPI();
  };

  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Card className="filterlist_of_cases filter_mui_1">
          <CardContent>
            <Grid container spacing={2}>
              {/* <Grid item md={4}>
                <Box className="" sx={{ pb: 2 }}>
                  <Typography gutterBottom variant="h5">
                    Incident Type
                  </Typography>
                </Box>
                <Box>
                  <FormGroup>
                    {filterType &&
                      filterType.map((item) => (
                        <FormControlLabel
                          key={item.id}
                          control={
                            <img
                              className="filterListCheckbox"
                              checked={
                                item.id == filter.incidentType ? true : false
                              }
                              alt=""
                              src={
                                item.id == filter.incidentType
                                  ? commonImages.check
                                  : commonImages.noCheck
                              }
                              onClick={() =>
                                setFilter((prevState) => ({
                                  ...prevState,
                                  incidentType: item.id,
                                }))
                              }
                            />
                          }
                          label={item?.title}
                        />
                      ))}
                  </FormGroup>
                </Box>
              </Grid> */}
              <Grid item md={12}>
                <Box className="" sx={{ pb: 2 }}>
                  <Typography className="filterLabel" gutterBottom variant="h5">
                    Time Period
                  </Typography>
                  <Box className="datePicker_row">
                    <div>
                      <Typography variant="subtitle1">From</Typography>
                      <FromToDatePicker
                        value={filter.startDate}
                        onChangeHandler={(value) =>
                          setFilter((prevState) => ({
                            ...prevState,
                            startDate: getFormatedDate(value),
                          }))
                        }
                      />
                    </div>
                    <div>
                      <Typography variant="subtitle1">To</Typography>
                      <FromToDatePicker
                        value={filter.endDate}
                        onChangeHandler={(value) =>
                          setFilter((prevState) => ({
                            ...prevState,
                            endDate: getFormatedDate(value),
                          }))
                        }
                      />
                    </div>
                  </Box>
                </Box>
                <Box className="" sx={{ pb: 2 }}>
                  <Typography className="filterLabel" gutterBottom variant="h5">
                    Status
                  </Typography>
                  <Box>
                    <FormGroup>
                      <FormControlLabel
                        key={INCIDENT_STATUS.SUBMITTED}
                        // label="Submitted"
                        control={
                          <img
                            className="filterListCheckbox"
                            checked={
                              filter.status == INCIDENT_STATUS.SUBMITTED
                                ? true
                                : false
                            }
                            alt=""
                            src={
                              filter.status == INCIDENT_STATUS.SUBMITTED
                                ? commonImages.check
                                : commonImages.noCheck
                            }
                            onClick={() =>
                              setFilter((prevState) => ({
                                ...prevState,
                                status: INCIDENT_STATUS.SUBMITTED,
                              }))
                            }
                          />
                        }
                        label={"Open"}
                      />
                      <FormControlLabel
                        key={INCIDENT_STATUS.CLOSED}
                        // label="Closed"
                        control={
                          <img
                            className="filterListCheckbox"
                            checked={
                              filter.status == INCIDENT_STATUS.CLOSED
                                ? true
                                : false
                            }
                            alt=""
                            src={
                              filter.status == INCIDENT_STATUS.CLOSED
                                ? commonImages.check
                                : commonImages.noCheck
                            }
                            onClick={() =>
                              setFilter((prevState) => ({
                                ...prevState,
                                status: INCIDENT_STATUS.CLOSED,
                              }))
                            }
                          />
                        }
                        label={"Closed"}
                      />
                      {bothRecords && (
                        <FormControlLabel
                          key={INCIDENT_STATUS.BOTH}
                          control={
                            <img
                              className="filterListCheckbox"
                              checked={
                                filter.status == INCIDENT_STATUS.BOTH
                                  ? true
                                  : false
                              }
                              alt=""
                              src={
                                filter.status == INCIDENT_STATUS.BOTH
                                  ? commonImages.check
                                  : commonImages.noCheck
                              }
                              onClick={() =>
                                setFilter((prevState) => ({
                                  ...prevState,
                                  status: INCIDENT_STATUS.BOTH,
                                }))
                              }
                            />
                          }
                          label={"All"}
                        />
                      )}
                    </FormGroup>
                  </Box>
                </Box>

                {origin && (
                  <>
                    <Box className="" sx={{ pb: 0.5 }}>
                      <Typography
                        className="filterLabel"
                        gutterBottom
                        variant="h5"
                      >
                        Origin
                      </Typography>
                    </Box>
                    <Box className="" sx={{ pb: 2 }}>
                      <SelectMenu
                        name={"origin"}
                        listData={ORIGIN}
                        onchangehandler={(e) => typeOnOriginChanges(e)}
                        value={originId}
                        placeholder="Please select"
                      />
                    </Box>
                  </>
                )}

                {assetTypes && (
                  <>
                    <Box className="" sx={{ pb: 0.5 }}>
                      <Typography
                        className="filterLabel"
                        gutterBottom
                        variant="h5"
                      >
                        Asset Type
                      </Typography>
                    </Box>
                    <Box className="" sx={{ pb: 2 }}>
                      <SelectMenu
                        name={"assetType"}
                        listData={ASSETTYPE}
                        onchangehandler={(e) => typeOnAssetChanges(e)}
                        value={assetTypeId}
                        placeholder="Please select"
                      />
                    </Box>
                  </>
                )}
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Buttons primary={true} label={"Reset"} onClick={resetFilter} />
            <Buttons
              primary={true}
              label={"Apply"}
              onClick={(e) => handleSearch(e, filter)}
            />
          </CardActions>
        </Card>
      </Popover>
    </>
  );
};

export default FilterIncidentList;
